export default __webpack_public_path__ + "static/media/BeeconLogoW.6655e2c0.png";